import React from "react"
import { Header } from "src/components/layout/header"
import { ReportTab } from "src/pages-lib/bonus-points/report-tab"

// История Tillypad: операции, которые видит клиент, по типам — кешбэк, покупки, сгорание.
export default function BonusPointsTillypad() {
  return (
    <>
      <Header title="Баллы: история Tillypad" />
      <ReportTab source="tillypad" />
    </>
  )
}
